export default "__VITE_ASSET__sESDCquS__"